module.exports = __webpack_public_path__ + "4d2bdf82f953e54160aaf86ca0b6bd5e.svg";